import {
  BigNumber,
  FormattableCurrency,
  toNativeCurrencyString,
  toUSDString,
} from '@ttx/core';
import {useCallback} from 'react';
import {ENVIRONMENT} from '../contexts/authentication-context/connectors';
import {useTtxQuery} from './ttx-trpc';

export const usePriceConversion: ({
  primaryCurrency,
  shouldPoll,
}: {
  primaryCurrency?: FormattableCurrency | null;
  shouldPoll?: boolean;
}) => {
  priceData: any;
  convertCryptoToUSD: (amount: BigNumber) => string | null;
} = ({primaryCurrency, shouldPoll}) => {
  const {data: priceData} = useTtxQuery(
    [
      'traxx.price',
      {
        currencies: ['USD'],
        primaryCurrency: primaryCurrency || 'MATIC',
        isProd: ENVIRONMENT === 'production',
      },
    ],
    {
      refetchInterval: shouldPoll ? 3000 : false,
    },
  );

  const convertCryptoToUSD = useCallback(
    (amount: BigNumber) => {
      if (!priceData || !priceData.length || !amount) return null;

      const nativePrice = Number(toNativeCurrencyString(amount, 'MATIC'));

      return priceData?.[0].price
        ? toUSDString(nativePrice * priceData?.[0].price)
        : null;
    },
    [priceData],
  );

  return {priceData, convertCryptoToUSD};
};
